// extracted by mini-css-extract-plugin
export default {"outrosPosts":"OutrosPosts_outrosPosts__kl0gl","postsCards":"OutrosPosts_postsCards__tiThX"};